import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { RadioButtonGroup as CoreRadioButtonGroup } from '@vds-core/inputs';
import DefaultRadioButton from './RadioButton';
var propTypes = {
  /**
   * If provided, Radio Button components will be rendered based on this data.
   * @typeName radioButtonData
   */
  data: PropTypes.arrayOf(PropTypes.shape({
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    selected: PropTypes.bool
  }))
};

var RadioButtonGroup = function RadioButtonGroup(props) {
  return /*#__PURE__*/React.createElement(CoreRadioButtonGroup, _extends({}, props, {
    RadioButton: DefaultRadioButton,
    errorState: true
  }));
};

RadioButtonGroup.propTypes = propTypes;
export default RadioButtonGroup;